<template>
    <div class="col l4 m6 s12">
    <router-link :to="'/nihom-content-view/'+data.id"><div class="card">
         <div class="card-image">
            <img :src="data.full_path" alt="">
         </div>
         <div>
            <h6>{{ data.title }}</h6>
         </div>
    </div></router-link>
    </div>
</template>
<script>
export default {
    props:["data"]
}
</script>
<style lang="scss" scoped>
        .card 
        {
           
            border-radius: 20px;
            text-align: center;
            padding-bottom: 20px;
        }

        .card-image img
        {
            border-radius: 20px 20px 0px 0px;
        }
        .card-image img 
        {
            height:200px;
        }

        .card h6 
        {
            line-height:35px;
        }

        .card:hover 
        {
            transition: 3s;
            transform:translateY(-20px);
        }
</style>